import { useLocalSearchParams } from 'expo-router';

import { WineToursScreen } from '@/components/riviera/wine-tours-screen';

export { generateWineCityStaticParams as generateStaticParams } from '@/lib/detail/wine-tours-detail';

// One departure city's wine tours, e.g. /en/wine-tours/cannes. Only cities with
// enough wine tours are exported — see generateWineCityStaticParams.
export default function WineToursCityScreen() {
  const { city } = useLocalSearchParams<{ city: string }>();
  return <WineToursScreen cityId={city ?? ''} />;
}
